module.exports = __webpack_public_path__ + "static/VEDL_Integrated_Annual_Report_2018_19-0f38b476bd9737242f19cbf54679092b.pdf";